import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { Card, Switch, Table, Typography, Space } from 'antd';
import TimeCell from "../../../components/TimeCell";
import PnL from "../../../components/PnL";
import {DoubleLine} from "../../../components/Labels";
import {portfolioTypeString} from "../../../utils/strings";
import {WarningSharp} from "@mui/icons-material";

// Custom hook for filtering portfolios
const useFilteredPortfolios = (portfolios, activeOnly) => {
  return useMemo(() => {
    return portfolios.filter(portfolio => !activeOnly || portfolio._user.in_use);
  }, [portfolios, activeOnly]);
};

const SignalCollectionTable = ({ portfolios }) => {
  portfolios.sort((a, b) => b?._user?.last_update || 0 - a?._user?.last_update || 0);
  const [activeOnly, setActiveOnly] = useState(true);

  const filteredPortfolios = useFilteredPortfolios(portfolios, activeOnly);

  const columns = useMemo(() => [
    {
      title: "View",
      key: "actions",
      render: (_, record) => <Link to={`/signals/${record.id}`}>VIEW</Link>,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (_, record)=> <DoubleLine title={record.name} text={portfolioTypeString(record.type)} />,
    },
    {
      title: 'Last Update',
      dataIndex: ['_user', 'last_update'],
      key: ['_user', 'last_update'],
      render: ts => <TimeCell timestamp={ts}/>,
      sorter: (a, b) => b?._user?.last_update - a?._user?.last_update,

    },
    {
      title: 'Last Ack',
      dataIndex: ['_user', 'last_ack'],
      key: ['_user', 'last_ack'],
      render: (ts) => {
        if (!ts || ts === 0) {
          return <Typography.Text type="danger">
            <WarningSharp fontSize={'small'}/> Never
          </Typography.Text>;
        }
        return <TimeCell timestamp={ts} />
      },
      sorter: (a, b) => b?._user?.last_ack - a?._user?.last_ack,
    },
    {
      title: "Changes",
      dataIndex: ['_user', 'change_count'],
      key: ['_user', 'change_count'],
      sorter: (a, b) => b?._user?.change_count - a?._user?.change_count,
      align: 'center',
    },
    {
      title: "Change (%)",
      dataIndex: ['_user', 'change_pct'],
      key: ['_user', 'change_pct'],
      render: (value) => <PnL value={value} multiplier={1} precision={3}/>,
      align: 'center',
    },
    {
      title: "All Changes",
      dataIndex: ['_user', 'total_change_count'],
      key: ['_user', 'total_change_count'],
      sorter: (a, b) => b?._user?.total_change_count - a?._user?.total_change_count,
      align: 'center',
    },
    {
      title: "All Change (%)",
      dataIndex: ['_user', 'total_change_pct'],
      key: ['_user', 'total_change_pct'],
      render: (value) => <PnL value={value} multiplier={1} precision={3}/>,
      align: 'center',
    }
  ], []);

  return (
      <Table
        columns={columns}
        dataSource={filteredPortfolios}
        rowKey="id"
        pagination={false}
        scroll={{ y: portfolios.length > 0 ? 800 : 200, x: 'max-content'}}
      />
  );
};

export default SignalCollectionTable;
